// React Modules
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import React, { useRef, useState } from 'react';
import Slider from 'react-slick';

//Components
import SlickNav from './SlickNav.js';

const SlickSliderShow = styled.div`
  .slick-initialized {
    display: block;
    visibility: visible;
  }
  .slick-track {
    display: flex;
    .osw & {
      padding-bottom: 20px;
    }
    // align-items: baseline;
  }
  .slick-slide {
    display: flex !important;
    height: inherit;
    justify-content: center;
    margin: 0 15px;
    div:has(> .product-details-pod) {
      height: 100%;
    }
    .product-details-pod {
      height: inherit;
    }
    .product-details-single {
      height: inherit;
      display: flex;
    }
    .similar-wines & {
      .product-details-single {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
      }
    }
    .recently-view-container & {
      .product-details-single {
        height: inherit;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }
  }
`;

const SlickSlider = ({ children, getActiveSlide, items, navEnabled, slidesToShow, setProduct }) => {
  const [state, setState] = useState({
    activeSlide: 0,
    arrowClicked: '',
  });
  let slider = useRef();

  /*
		Trigger Slick Slider to Next Slide
	 */
  const nextSlide = () => {
    slider.slickNext();
    if (setProduct) {
      let itemArray =
        items.length - 1 == slider.innerSlider.state.currentSlide ? 0 : slider.innerSlider.state.currentSlide + 1;
      setProduct(items[itemArray].referencedProduct);
    }
  };

  /*
		Trigger Slick Slider to Previous Slide
	 */
  const previousSlide = () => {
    slider.slickPrev();
    if (setProduct) {
      let itemArray =
        slider.innerSlider.state.currentSlide == 0 ? items.length - 1 : slider.innerSlider.state.currentSlide - 1;
      setProduct(items[itemArray].referencedProduct);
    }
  };

  /*
		Go to Slide
	 */
  const goToSlide = index => {
    slider.slickGoTo(index);
    if (setProduct) {
      setProduct(items[index].referencedProduct);
    }
  };

  /*
		Get Current Item / Slide
	 */
  const getCurrentItem = currentSlide => {
    /*
	   Pass Active Slide Back Down
		  */
    if (getActiveSlide) {
      getActiveSlide(currentSlide);
    }
    /*
			   Update Active Slide State
		   */
    setState(prevState => {
      return {
        ...prevState,
        activeSlide: currentSlide,
      };
    });
  };

  /*
	Slides To Show
*/
  slidesToShow = items.length <= slidesToShow ? items.length : slidesToShow;

  /*
	Check if nav is enabled
	If nav enabled is prop is false or
	number of items equal to 1 - disable nav
*/
  navEnabled = !navEnabled || items.length <= slidesToShow ? false : true;
  /*
	Figure out how many dots to show
	in the navigation
	*/
  let dotCount = slidesToShow === 1 ? items.length : items.length / slidesToShow;

  /*
	Check if Mobile
	if so then updates the dotCount
	and slides to show variables
	*/
  if (window.innerWidth < 768) {
    dotCount = items.length;
    slidesToShow = 1;
    navEnabled = !navEnabled || items.length === slidesToShow ? false : true;
  }

  let enableSwipe = slidesToShow === items.length ? false : true;
  /*
		Slick Settings
		*/
  const settings = {
    infinite: navEnabled,
    arrows: false,
    speed: 500,
    swipe: enableSwipe,
    slidesToShow: slidesToShow ? slidesToShow : 1,
    slidesToScroll: slidesToShow ? slidesToShow : 1,
    afterChange: getCurrentItem,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: enableSwipe,
        },
      },
    ],
  };

  return (
    <SlickSliderShow className="clearfix">
      <Slider ref={c => (slider = c)} {...settings}>
        {children}
      </Slider>
      {navEnabled ? (
        <SlickNav
          dotCount={dotCount}
          activeSlide={state.activeSlide}
          previousSlide={previousSlide}
          goToSlide={goToSlide}
          nextSlide={nextSlide}
          slidesToShow={slidesToShow}
        />
      ) : (
        false
      )}
    </SlickSliderShow>
  );
};

/*
	 Define Prop types
 */
SlickSlider.propTypes = {
  items: PropTypes.array.isRequired,
  navEnabled: PropTypes.bool.isRequired,
  slidesToShow: PropTypes.number.isRequired,
  children: PropTypes.array.isRequired,
  getActiveSlide: PropTypes.func,
};

export default SlickSlider;
